import { assign } from '@antv/util';
import { getEventMap, EVENT_MAP, onEvent } from '../../util/event';
var componentMap = {
    bar: 'interval',
};
var SHAPE_EVENT_MAP = getEventMap(componentMap);
assign(EVENT_MAP, SHAPE_EVENT_MAP);
export { EVENT_MAP, onEvent };
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/plots/bar/event.js
// module id = null
// module chunks = 